import { TrackingAction, TrackingCategory } from './tracking.enum';

export class TrackingEvent {
    action: TrackingAction;
    properties: TrackingProperties;
}

export class TrackingProperties {
    category: TrackingCategory;
    name: string;
    value?: number;
}

export const TrackingName = {
    NOMBRE_PIECES_COMPLEMENTAIRES: 'Nombre de pièces complémentaires',
    NOMBRE_PIECES_POSTALES: 'Nombre de pièces postales',
    NOMBRE_REQUERANTS_REQUETE_COLLECTIVE: 'Nombre de requérants secondaires',
    NOMBRE_MANDANTS: 'Nombre de mandants',
    PREVIEW_INVENTORY: 'Apercu de l\'inventaire',
    GENERAL: 'Général'
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/model/tracking/tracking.model.ts